import { render, staticRenderFns } from "./renewalDetails.vue?vue&type=template&id=46c497da&scoped=true&"
import script from "./renewalDetails.vue?vue&type=script&lang=js&"
export * from "./renewalDetails.vue?vue&type=script&lang=js&"
import style0 from "./renewalDetails.vue?vue&type=style&index=0&id=46c497da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c497da",
  null
  
)

export default component.exports